import { Box, Typography } from "@mui/material";
import useIsMobile from "components/hooks/useIsMobile";
import { format } from "date-fns";

export default ({
  date,
  compact = false,
}: {
  date: Date;
  compact?: boolean;
}) => {
  const day = format(date, "EEE");
  const dateNum = format(date, "d");
  const isMobile = useIsMobile();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: compact && !isMobile ? "row-reverse" : "column",
        alignItems: "center",
        gap: compact ? "8px" : "0",
      }}
    >
      <Typography variant="bodySmall">{day}</Typography>
      <Typography variant={compact ? "bodyHeavy" : "h4"}>{dateNum}</Typography>
    </Box>
  );
};
